import React from 'react';
import './DynamicGrid.css';

const DynamicGrid = ({ 
  buttons, 
  layout = 'desktop', // 'desktop' nebo 'mobile'
  maxButtons = 9,
  isDarkMode = false 
}) => {
  // Pro mobilní layout stále filtrujeme skrytá tlačítka
  if (layout === 'mobile') {
    const visibleButtons = buttons.filter(button => !button.hidden);
    const limitedButtons = visibleButtons.slice(0, maxButtons);
    
    return (
      <div className="dynamic-grid-mobile">
        {limitedButtons.map((button, index) => (
          <button
            key={button.id || index}
            className={`grid-button ${button.colorClass || 'btn-blue'} ${button.fullWidth ? 'full-width' : ''}`}
            onClick={button.onClick}
            disabled={button.disabled}
            title={button.title}
            style={{
              marginRight: button.fullWidth ? '0' : undefined,
              marginBottom: '0.5rem'
            }}
          >
            {button.icon && <span className="mr-1">{button.icon}</span>}
            {button.label}
          </button>
        ))}
      </div>
    );
  }

  // Desktop layout - zachováváme pozice, skrytá tlačítka zůstávají jako prázdná místa
  const allButtons = buttons.slice(0, maxButtons);
  
  // Rozdělíme tlačítka do 3 řádků po 3 tlačítkách
  const rows = [];
  for (let i = 0; i < allButtons.length; i += 3) {
    rows.push(allButtons.slice(i, i + 3));
  }

  return (
    <div className="dynamic-grid-desktop-fixed">
      {rows.map((rowButtons, rowIndex) => (
        <div key={rowIndex} className="grid-row">
          {[0, 1, 2].map((colIndex) => {
            const button = rowButtons[colIndex];
            
            if (!button || button.hidden) {
              // Prázdné místo pro skryté nebo neexistující tlačítko
              return (
                <div key={`empty-${rowIndex}-${colIndex}`} className="grid-button-placeholder">
                </div>
              );
            }
            
            return (
              <button
                key={button.id || `${rowIndex}-${colIndex}`}
                className={`grid-button ${button.colorClass || 'btn-blue'}`}
                onClick={button.onClick}
                disabled={button.disabled}
                title={button.title}
              >
                {button.icon && <span className="mr-1">{button.icon}</span>}
                {button.label}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default DynamicGrid;
